import { useEffect, useRef } from "react";

export function useRefreshOnVisibility({
  thresholdMinutes = 15,
  onExpire = () => window.location.reload(),
}: {
  thresholdMinutes?: number;
  onExpire?: () => void;
}) {
  const lastCheck = useRef(Date.now());

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        const now = Date.now();
        const minutes = (now - lastCheck.current) / 1000 / 60;
        if (minutes > thresholdMinutes) {
          onExpire();
        }
        lastCheck.current = now;
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibility);
  }, [thresholdMinutes, onExpire]);
}
